import $lodash from 'lodash'
import dataReducer from '@/utils/data/dataReducerForSpeed'

const types = {
  SET_OPTION_DATA: 'speedCalculation2/SET_OPTION_DATA',
  SET_SELECTED_DATA: 'speedCalculation2/SET_SELECTED_DATA',
  UPDATE_SELECTED_DATA: 'speedCalculation2/UPDATE_SELECTED_DATA',
  UPDATE_SELECTED_DATA_ALL_PRODUCT_LINE: 'speedCalculation2/UPDATE_SELECTED_DATA_ALL_PRODUCT_LINE',
  RESET_SELECTED_DATA: 'speedCalculation2/RESET_SELECTED_DATA',
  SET_SELECTED_PRODUCT_LINE: 'speedCalculation2/SET_SELECTED_PRODUCT_LINE',
  SET_PRODUCT_LINE_STATUS: 'speedCalculation2/SET_PRODUCT_LINE_STATUS',
  SET_ALL_PRODUCT_LINE_STATUS: 'speedCalculation2/SET_ALL_PRODUCT_LINE_STATUS',
  UPDATE_REQUIRE_CHECK_DATA: 'speedCalculation2/UPDATE_REQUIRE_CHECK_DATA',
  ADD_COMPARE_DATA: 'speedCalculation2/ADD_COMPARE_DATA',
  REMOVE_COMPARE_DATA: 'speedCalculation2/REMOVE_COMPARE_DATA',
  TOGGLE_COMPARE_CHART_DISPLAY: 'speedCalculation2/TOGGLE_COMPARE_CHART_DISPLAY',
  CLONE_SELECTED_DATA: 'speedCalculation2/CLONE_SELECTED_DATA',
  SET_IS_FROM_GUIDE: 'speedCalculation2/SET_IS_FROM_GUIDE',
  SET_IS_FROM_CALCULATION: 'speedCalculation2/SET_IS_FROM_CALCULATION',
  SET_RESULT_FROM_GUIDE: 'speedCalculation2/SET_RESULT_FROM_GUIDE',
  SHOW_BACK_BUTTON: 'speedCalculation2/SHOW_BACK_BUTTON',
  UPDATE_CALCULATION_RESULT: 'speedCalculation2/UPDATE_CALCULATION_RESULT'
}
// 預設的空選項
const defaultOptions = () => {
  return {
    flv_second: [],
    freq: 2,
    demographics: {
      male: [],
      female: []
    },
    hourlies: [],
    interests: [],
    keywords: [],
    medias: {
      categories: []
    },
    cities: {
      regions: [],
      municipalities: []
    },
    isps: [],
    device_brands: [],
    product_lines: {
      SuperImpact: {},
      SuperView: {},
      LINEToday: {}
    }
  }
}

const defaultProductLine = {
  SuperImpact: 9,
  SuperView: 10,
  LINEToday: 4
}

// 選項必填檢查
const defaultRequireCheckList = () => {
  return {
    flvSecond: true,
    frequency: true,
    demographics: true,
    hourlies: true,
    interestKeyword: true,
    media: true,
    cities: true,
    isps: true,
    deviceBrands: true,
    budgetReach: true,
    playDate: true,
    platformType: true,
    formatSelector: true,
    budgetDistribution: true
  }
}

const productLineStatus = [
  '預設選項',
  '已帶入規劃建議資料',
  '已修改'
]

// 儲存各個產品線的表單修改狀態
const defaultProductLineStatus = () => {
  // 0: 預設選項
  // 1: 已帶入規劃建議資料
  // 2: 已修改
  return {
    SuperImpact: 0,
    SuperView: 0,
    LINEToday: 0
  }
}

const state = {
  options: defaultOptions(),
  selectedData: {},
  selectedProductLine: 'SuperImpact', // 'SuperImpact', 'SuperView', 'LINEToday'
  calculationResult: null,
  requireCheckList: defaultRequireCheckList(),
  compareDataLimit: 10, // 比較上限
  compareDataList: [],
  isFromGuide: false,
  isFromCalculation: false,
  resultFromGuide: false,
  showBackButton: false,
  productLineStatus: defaultProductLineStatus()
}

const getters = {
  // 檢查所有選項是否都通過必填檢驗
  requireAllPass: (state, getters, rootState, rootGetters) => {
    return Object.values(state.requireCheckList).every(warningText => !warningText) &&
          rootState.root.baseInfoChecked === true
  },
  // 判斷是否已達比較上限
  isCompareDataLimit: state => { return state.compareDataList.length >= state.compareDataLimit },

  // 依據目前選擇產品線，傳回表單已選擇的選項
  selectedData: state => { return state.selectedData[state.selectedProductLine] },

  // 取得產品線計算表單的狀態的code與對應的狀態文字
  // { 'Superimpact': { statusCode: 0, statusText: '預設選項' }, ... }
  productLineStatusInText: state => {
    let retval = {}
    Object.keys(state.productLineStatus).forEach(key => {
      retval[key] = {
        statusCode: state.productLineStatus[key],
        statusText: productLineStatus[state.productLineStatus[key]]
      }
    })
    return retval
  }
}

const actions = {
  // 設定選項
  setOptions ({ commit, dispatch, rootGetters }, data) {
    commit(types.SET_OPTION_DATA, { data, rootGetters })
    dispatch('resetSelectedData', data)
  },
  // LOAD FAVORITE DATA AND THEN USE IT
  setSelectedData ({ commit }, data) {
    commit(types.SET_SELECTED_DATA, data)
  },
  setSelectedProductLine ({ commit }, data) {
    commit(types.SET_SELECTED_PRODUCT_LINE, data)
  },
  setProductLineStatus ({ commit }, data) {
    commit(types.SET_PRODUCT_LINE_STATUS, data)
  },
  setAllProductLineStatus ({ commit }, data) {
    commit(types.SET_ALL_PRODUCT_LINE_STATUS, data)
  },
  // 更新選擇資料
  updateSelectedData ({ commit }, data) {
    commit(types.UPDATE_SELECTED_DATA, data)
  },
  // 更新所有產品線的選擇資料
  updateSelectedDataForAllProductLines ({ commit }, data) {
    commit(types.UPDATE_SELECTED_DATA_ALL_PRODUCT_LINE, data)
  },
  // 清空選擇資料
  // 但如果是 agency 或 client，要再設定代理商名或是客戶名
  resetSelectedData ({ commit, dispatch, rootGetters }) {
    commit(types.RESET_SELECTED_DATA, rootGetters)
    dispatch('root/resetSelectedData', null, { root: true })
  },
  // 更新欄位檢查狀態
  updateRequireCheckData ({ commit }, data) {
    commit(types.UPDATE_REQUIRE_CHECK_DATA, data)
  },
  // 新增比較
  addCompareData ({ commit }, data) {
    commit(types.ADD_COMPARE_DATA, data)
  },
  // 移除比較
  removeCompareData ({ commit }, index) {
    commit(types.REMOVE_COMPARE_DATA, index)
  },
  // 切換該index比較圖表顯示/隱藏
  toggleCompareChartDisplay ({ commit }, index) {
    commit(types.TOGGLE_COMPARE_CHART_DISPLAY, index)
  },
  cloneSelectedData ({ commit, rootGetters }, data) {
    const emptySelectedData = dataReducer.getDefaultSelectedData(state.options, rootGetters)
    // NOTE:
    // Zone Please note that this is not a deep operation
    // if the data don't have the correct property and structure, error will occur in later process
    const newData = { ...emptySelectedData, ...data }
    commit(types.CLONE_SELECTED_DATA, newData)
  },
  setIsFromGuide ({ commit }, data) {
    commit(types.SET_IS_FROM_GUIDE, data)
  },
  setIsFromCalculation ({ commit }, data) {
    commit(types.SET_IS_FROM_CALCULATION, data)
  },
  setResultFromGuide ({ commit }, data) {
    commit(types.SET_RESULT_FROM_GUIDE, data)
  },
  setShowBackButton ({ commit }, data) {
    commit(types.SHOW_BACK_BUTTON, data)
  },
  updateCalculationResult ({ commit }, data) {
    commit(types.UPDATE_CALCULATION_RESULT, data)
  }
}

const mutations = {
  [types.SET_OPTION_DATA] (state, { data }) {
    Object.assign(state.options, data)
  },
  [types.SET_SELECTED_DATA] (state, data) {
    state.selectedData = data
  },
  [types.UPDATE_SELECTED_DATA] (state, data) {
    const cloneData = $lodash.cloneDeep(data)
    cloneData.forEach(item => {
      $lodash.set(state.selectedData[state.selectedProductLine], item.key, item.value)
    })
  },
  [types.UPDATE_SELECTED_DATA_ALL_PRODUCT_LINE] (state, data) {
    const cloneData = $lodash.cloneDeep(data)
    const productLines = Object.keys(defaultProductLine)
    cloneData.forEach(item => {
      productLines.forEach(productLineName => {
        $lodash.set(state.selectedData[productLineName], item.key, item.value)
      })
    })
  },
  [types.CLONE_SELECTED_DATA] (state, data) {
    state.selectedData = $lodash.cloneDeep(data)
  },
  [types.RESET_SELECTED_DATA] (state, rootGetters) {
    state.selectedData = dataReducer.getDefaultSelectedData(state.options, rootGetters)
  },
  [types.SET_SELECTED_PRODUCT_LINE] (state, data) {
    state.selectedProductLine = data
  },
  [types.SET_PRODUCT_LINE_STATUS] (state, data) {
    Object.keys(data).forEach(productline => {
      state.productLineStatus[productline] = data[productline]
    })
  },
  [types.SET_ALL_PRODUCT_LINE_STATUS] (state, data) {
    Object.keys(state.productLineStatus).forEach(productline => {
      state.productLineStatus[productline] = data
    })
  },
  [types.UPDATE_REQUIRE_CHECK_DATA] (state, data) {
    const cloneData = $lodash.cloneDeep(data)
    state.requireCheckList[cloneData.key] = cloneData.value
  },
  [types.ADD_COMPARE_DATA] (state, data) {
    data.display = true
    state.compareDataList.push(data)
  },
  [types.TOGGLE_COMPARE_CHART_DISPLAY] (state, index) {
    state.compareDataList[index].display = !state.compareDataList[index].display
  },
  [types.REMOVE_COMPARE_DATA] (state, index) {
    state.compareDataList.splice(index, 1)
  },
  [types.SET_IS_FROM_GUIDE] (state, data) {
    state.isFromGuide = data
  },
  [types.SET_IS_FROM_CALCULATION] (state, data) {
    state.isFromCalculation = data
  },
  [types.SET_RESULT_FROM_GUIDE] (state, data) {
    state.resultFromGuide = data
  },
  [types.SHOW_BACK_BUTTON] (state, data) {
    state.showBackButton = data
  },
  [types.UPDATE_CALCULATION_RESULT] (state, data) {
    state.calculationResult = $lodash.cloneDeep(data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
